import React from "react";
import {
  FormControl,
  FormHelperText,
  TextField,
  Autocomplete,
} from "@mui/material";
import "./CustomDropdownMultiSelect.css";

// const StyledInputLabel = styled(InputLabel)({
//   "& .MuiFormLabel-asterisk": {
//     color: "red",
//   },
// });

interface CustomDropdownMultiSelectProps {
  label: string;
  name: string;
  value: any[];
  options: any[]; 
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  onChange: (value: any[]) => void;
}

const CustomDropdownMultiSelect: React.FC<CustomDropdownMultiSelectProps> = (
  props,
) => {
  const {
    name,
    label,
    value,
    options,
    error,
    helperText,
    required,
    disabled,
    className,
    onChange,
  } = props;

  const fieldClasses =
    className !== undefined ? `dd_field ${className}` : "dd_field";

  return (
    <FormControl className={fieldClasses} error={error} fullWidth>

      <Autocomplete
        id="fixed-tags-demo"
        multiple
        options={options}
        value={value}
        disabled={disabled}
        onChange={(_, newValue) => onChange(newValue)}
        getOptionLabel={(option) =>
          typeof option === "string"
            ? option
            : option.label || option.name || ""
        }
        isOptionEqualToValue={(option, val) => option.id === val.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            name={name}
            error={error}
            required={required}
          />
        )}
        sx={{
          ".MuiOutlinedInput-notchedOutline": {
            border: "2px solid #0146C6",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0146C6",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0146C6",
          },
        }}
      />

      <FormHelperText>{error ? helperText : ""}</FormHelperText>
    </FormControl>
  );
};

export default CustomDropdownMultiSelect;
